import axios from "axios";
// import { router } from '../routes.js'

const errorHandle = (status, msg) => {
  console.log(msg);
  switch (status) {
    case 400:
      break;
    case 404:
      break;
    case 500:
      break;

    default:
      console.log("攔不到錯誤QQ");
  }
};

var instance = axios.create({
  baseURL: process.env.VUE_APP_API_ENDPOINT,
});

instance.interceptors.request.use(
  (config) => {
    const authorization = localStorage.getItem("authorization_token");
    config.headers.Authorization = "Bearer " + authorization;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const { response } = error;

    if (response) {
      errorHandle(response.status, response.data.error);
    }

    return Promise.reject(error);
  }
);

export default function (method, url, data = null) {
  method = method.toLowerCase();

  switch (method) {
    case "get":
      return instance.get(url, { params: data });

    case "post":
      return instance.post(url, data);

    case "put":
      return instance.put(url, data);

    case "patch":
      return instance.patch(url, data);

    case "delete":
      return instance.delete(url, { data: data });

    default:
      console.error("unknown_request_method" + method);
      return false;
  }
}
